<template lang="pug">
v-skeleton-loader(
    v-if="isLoading"
    :loading="true"
    type="avatar"
)
div(v-else).suus__status-icon.pa-2
    transition(name="fade")
        v-avatar(color="primary" size="30" v-if="icon")
            v-icon( color="white") {{ icon }}
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "StatusIcon",
  props: {
    icon: String,
    isLoading: { type: Boolean, default: false },
  },
})
</script>

<style lang="sass">
$primary-color: rgba(69, 127, 252, 1)
$primary-light: rgba(226, 235, 255, 1)
.fade-enter-active, .fade-leave-active
    transition: all .5s cubic-bezier(.47,1.64,.41,.8)
.fade-enter, .fade-leave-to
    opacity: 0
    transform: scale(1.1)
.suus__status-icon
    width: 46px
    height: 46px
    width: fit-content
    border-radius: 50%
    background-color: $primary-light
</style>
